import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';
import { auth } from '../firebase';
import '../styles/LoginPage.css';

const LoginPage = () => {
  const [isFromApp, setIsFromApp] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is coming from mobile app
    const urlParams = new URLSearchParams(window.location.search);
    const fromApp = urlParams.get('fromApp');
    const redirect = urlParams.get('redirectUrl');

    if (fromApp === 'true') {
      setIsFromApp(true);
      setRedirectUrl(redirect || '');
    }

    // Check if user is already logged in
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user && fromApp === 'true') {
        // User is logged in and came from app, redirect back
        if (redirect) {
          window.location.href = redirect;
        } else {
          // Default redirect to mobile app
          window.location.href = 'logicar://auth?success=true';
        }
      }
    });

    return () => unsubscribe();
  }, []);

  const handleMobileRedirect = () => {
    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      window.location.href = 'logicar://auth';
    }
  };

  return (
    <div className="login-page">
      <SEO 
        title="Login - LogiCar"
        description="Login to your LogiCar account to access your vehicle maintenance dashboard."
        canonical="https://www.logicarapp.com/login"
      />
      
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <h1>LogiCar Login</h1>
            <p>Access your vehicle maintenance dashboard</p>
          </div>

          {isFromApp ? (
            <div className="mobile-login">
              <div className="mobile-info">
                <i className="fas fa-mobile-alt"></i>
                <h3>Mobile App Authentication</h3>
                <p>You're being redirected from the LogiCar mobile app. Please log in to continue.</p>
              </div>
              
              <div className="login-options">
                <button 
                  onClick={() => navigate('/')}
                  className="web-login-btn"
                >
                  <i className="fas fa-globe"></i>
                  Login on Web
                </button>
                
                <button 
                  onClick={handleMobileRedirect}
                  className="mobile-redirect-btn"
                >
                  <i className="fas fa-arrow-left"></i>
                  Return to App
                </button>
              </div>
            </div>
          ) : (
            <div className="web-login">
              <div className="login-info">
                <i className="fas fa-car"></i>
                <h3>Welcome to LogiCar</h3>
                <p>Manage your vehicle maintenance with our comprehensive dashboard.</p>
              </div>
              
              <div className="login-actions">
                <button 
                  onClick={() => navigate('/')}
                  className="home-btn"
                >
                  <i className="fas fa-home"></i>
                  Go to Homepage
                </button>
                
                <button 
                  onClick={() => navigate('/dashboard')}
                  className="dashboard-btn"
                >
                  <i className="fas fa-tachometer-alt"></i>
                  Access Dashboard
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
